import { useState } from "react";
import { Link, useRouteLoaderData, useSubmit } from "react-router-dom";
import { saveAs } from "file-saver";
import UserInfo from "src/components/common/userInfo";
import { useAuthStore, User } from "src/components/main/authStore";
import { 
    getFileNameFromUrl, 
    testerEmails
} from "src/components/common/functions";
import { Data } from "./types";
export default function TimeOffDetail(){
    const { timeOff } = useRouteLoaderData("TimeOff");
    const user = useAuthStore(state => state.user) as User;
    const [comments, setComments] = useState("");
    const submit = useSubmit();
    function handleDelete(id:number){
        if(!window.confirm("Are you sure to delete this time off form?\n\nThis action cannot be undone.")) return;
        const formData = new FormData();
        formData.append("id", String(id));
        submit(formData, {
            method: "post",
            action: "Delete"
        });
    }
    const handleDownload = async (pdfId: string) => {
        try{
            const response = await fetch(pdfId);
            if(!response.ok) throw new Error("Failed to fetch file");
            saveAs(await response.blob(), getFileNameFromUrl(pdfId)!);
        }catch(error){
            window.alert("Error downloading file:" + error);
        }
    }
    function handleValidate(id:number){
        if(!window.confirm("Are you sure to validate this time off form?")) return;
        let validateReason = window.prompt("reason to validdate:");
        if(validateReason === null) return;
        while(validateReason === ""){
            window.alert("Reason is required to validate.");
            validateReason = window.prompt("reason to validate:");
            if(validateReason === null) return;
        }
        const formData = new FormData();
        formData.append("validateReason", validateReason);
        formData.append("id", String(id));
        submit(formData, {
            method: "post",
            action: "Validate"
        });
    }
    const notifyTimeOff = async (id:number) => {
        if(!window.confirm("Are you sure to notify the approver?")) return;
        const formData = new FormData();
        formData.append("id", String(id));
        submit(formData, {
            method: "post",
            action: "Notify"
        });
    };
    const voidTimeOff = async (id:number) => {
        if(!window.confirm("Are you sure to void this time off form?")) return;
        let voidReason = window.prompt("reason to void:");
        if(voidReason === null) return;
        while(voidReason === ""){
            window.alert("Reason is required to void.");
            voidReason = window.prompt("reason to void:");
            if(voidReason === null) return;
        }
        const formData = new FormData();
        formData.append("voidReason", voidReason);
        formData.append("id", String(id));
        submit(formData, {
            method: "post",
            action: "Void"
        });
    }
    const handleApproval = (id:number, d:{ decision: string, word: string}, comments: string) => {
        if(d.word === "reject" && !comments){
            window.alert("Comments are required for rejection.");
            return;
        }
        if(!window.confirm(`Are you sure to ${d.word} this absence request?`)) return;
        const formData = new FormData();
        formData.append("id", String(id));
        formData.append("approverDecision", d.decision);
        formData.append("approverNotes", comments);
        submit(formData, {
            method: "post",
            action: "Approve"
        });
    }
    return(
    <div className = "border" style = {{borderRadius: "6px"}}>
        <div style = {{display: "flex"}}>
            <table className = "table table-responsive-xl noTopBorder">
                <tbody>
                    <tr>
                        <th>Status</th>
                        <td><span children = {timeOff.status} className = "badge text-bg-primary ms-2"/></td>
                    </tr>
                    <tr>
                        <th>Requester</th>
                        <td>
                            <UserInfo 
                                name = {timeOff.requester.label}
                                id = {timeOff.requester.value}
                            />
                        </td>
                    </tr>
                    <tr>
                        <th>Department</th>
                        <td><span children = {timeOff.requester.department} className = "ms-2"/></td>
                    </tr>
                    <tr>
                        <th>Type</th>
                        <td><span children = {timeOff.type} className = "ms-2"/></td>
                    </tr>
                    <tr>
                        <th>Notes</th>
                        <td><span children = {timeOff.notes} style = {{ whiteSpace: "pre-wrap" }} className = "ms-2"/></td>
                    </tr>
                    <tr>
                        <th>Dates</th>
                        <td>
                            <span children = {timeOff.fromDate}/> - <span children = {timeOff.toDate}/>
                        </td>
                    </tr>
                    {timeOff.requester.outside === "no"?<tr>
                        <td colSpan = {2}>
                            <strong>Detail Hours:</strong>
                            <span className  = "ms-3">(2-hour increment)</span>
                            <ul>
                                {timeOff.data.map((v: Data, i: number) => <li key = {i} className = "my-3">
                                    <span className = "me-2">{v.date}</span>
                                    {v.holiday || v.weekend?null:<>
                                    <span className = "blk3">
                                        {Number(v.hours) < 8?<span className = "me-2">start from {v.startTime}</span>:<></>}
                                        <span className = "me-2">{v.hours} hours</span>
                                    </span>
                                    </>}
                                    {v.holiday?<span className = "me-2 text-info">({v.holidayName})</span>:null}
                                    {v.weekend?<span className = "me-2 text-success">(weekend)</span>:null}
                                </li>)}
                            </ul>
                            {timeOff.data.length?
                            <div className = "fw-bold">
                                Total: <span style = {{color: "green"}}>{timeOff.totalHours} hours</span>
                            </div>
                            :null}
                        </td>
                    </tr>:null}
                    {timeOff.notifiedAt?
                    <tr>
                        <th>Notified By</th>
                        <td>
                            <UserInfo 
                                name = {timeOff.creatorName}
                                id = {timeOff.notifiedBy}
                            /> 
                            <span children = {timeOff.notifiedAt} className = "ms-2"/>
                        </td>
                    </tr>
                    :null}
                    <tr>
                        <th>Approver Name</th>
                        <td>
                            <UserInfo 
                                name = {timeOff.approver.label}
                                id = {timeOff.value}
                            />
                        </td>
                    </tr>
                    <tr>
                        <th>Review Time</th>
                        <td>{timeOff.approvalTime}</td>
                    </tr>
                    <tr>
                        <th>Approver Comments</th>
                        <td><span children = {timeOff.approverNotes}  style = {{ whiteSpace: "pre-wrap" }} className = "ms-2"/></td>
                    </tr>
                    <tr>
                        <th>Creator</th>
                        <td>
                            <UserInfo 
                                name = {timeOff.creatorName}
                                id = {timeOff.creatorId}
                            />
                            <span children = {timeOff.createdAt} className = "ms-2"/>
                        </td>
                    </tr>
                    {timeOff.updaterId?
                    <tr>
                        <th>Updater</th>
                        <td>
                            <UserInfo 
                                name = {timeOff.updaterName}
                                id = {timeOff.updaterId}
                            />
                            <span children = {timeOff.updatedAt} className = "ms-2"/>
                        </td>
                    </tr>
                    :null}
                    {timeOff.void === "yes"?
                    <tr>
                        <th className = "text-danger">Void Reason</th>
                        <td>{timeOff.voidReason}</td>
                    </tr>
                    :<></>}
                </tbody>
            </table>
        </div>
        <div className="mb-3">
            {timeOff.void === "yes"?<>
                {testerEmails.includes(user.email)?
                <button
                    children = "Validate"
                    className = "btn btn-primary"
                    onClick = {() => handleValidate(timeOff.id)}
                />:null}
            </>:
            <>
            <Link
                children = "Edit"
                to = "Edit"
                className = "btn btn-outline-primary"
            />
            <button
                children = "Void"
                type = "button"
                className = "btn btn-danger ms-2"
                onClick = {() => voidTimeOff(timeOff.id)}
            />
            <button
                children = "Notify"
                type = "button"
                className = "btn btn-info ms-2"
                onClick = {() => notifyTimeOff(timeOff.id)}
            />
            </>}
            {timeOff.void === "yes"?
            <button
                children = "Delete"
                className = "btn btn-danger ms-2"
                onClick = {() => handleDelete(timeOff.id)}
            />:null}
            {timeOff.pdfId?
            <button
                children = "PDF"
                type = "button"
                className = "btn btn-primary ms-2"
                onClick = {() => handleDownload(timeOff.pdfId)}
            />:null}
            <Link
                children = "Back"
                to = ".."
                relative = "path"
                className = "btn btn-outline-secondary float-end"
            />
        </div>
        {timeOff.void === "no" && timeOff.approver.value === user.id && !["Approved", "Rejected"].includes(timeOff.status)?<>
        <div className = "mx-3 mb-3 fw-bold">Approver Comments</div>
        <textarea className = "form-control mx-3" rows = {4} style = {{minWidth: 300, width: "20%"}} value = {comments} onChange = {e => {setComments(e.currentTarget.value)}} name = "comments"/>
        <div>
            {[
                {title:"Approve", decision: "Approved", word: "approve", color: "btn-success"}, 
                {title:"Reject", decision: "Rejected", word: "reject", color: "btn-danger"}
            ].map((d, di) => 
            <span key = {di} className = {`btn ${d.color} m-3`} onClick = {() => handleApproval(timeOff.id, d, comments)}>{d.title}</span>)}
        </div>
        </>:null}
    </div>
    )
}